var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 35,
    viewBox: "0 0 74 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.0795 29.24H33.1895C31.5795 29.24 30.2695 27.93 30.2695 26.32V2.92C30.2695 1.31 31.5795 0 33.1895 0H71.0795C72.6895 0 73.9995 1.31 73.9995 2.92V26.32C73.9995 27.93 72.6895 29.24 71.0795 29.24Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.81 34.9998H2.92C1.31 34.9998 0 33.6898 0 32.0798V8.67977C0 7.06977 1.31 5.75977 2.92 5.75977H40.81C42.42 5.75977 43.73 7.06977 43.73 8.67977V32.0798C43.73 33.6898 42.42 34.9998 40.81 34.9998Z",
    fill: "#F68637"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 10.7197H0V16.1697H43.73V10.7197Z",
    fill: "#676868"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2886 28.43H7.42859C6.39859 28.43 5.55859 27.59 5.55859 26.56V23.37C5.55859 22.34 6.39859 21.5 7.42859 21.5H36.2886C37.3186 21.5 38.1586 22.34 38.1586 23.37V26.56C38.1686 27.6 37.3286 28.43 36.2886 28.43Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2209 15.8805C57.126 15.8805 59.4809 13.5703 59.4809 10.7205C59.4809 7.87076 57.126 5.56055 54.2209 5.56055C51.3159 5.56055 48.9609 7.87076 48.9609 10.7205C48.9609 13.5703 51.3159 15.8805 54.2209 15.8805Z",
    fill: "#ED7061"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3108 15.8805C65.2158 15.8805 67.5708 13.5703 67.5708 10.7205C67.5708 7.87076 65.2158 5.56055 62.3108 5.56055C59.4058 5.56055 57.0508 7.87076 57.0508 10.7205C57.0508 13.5703 59.4058 15.8805 62.3108 15.8805Z",
    fill: "#FFCC68"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2987 21.5H43.7188V24.47H50.2987C50.5287 24.47 50.7188 24.29 50.7188 24.06V21.9C50.7188 21.68 50.5287 21.5 50.2987 21.5Z",
    fill: "#B4B2B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.1e96d65bba0207db17fd618b0abbfe85.svg";
export { ForwardRef as ReactComponent };